// VERSION DEL SISTEMA
export const SYSVERSION: String = "1.53.1";



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/config/app.config.ts